export default __webpack_public_path__ + "static/media/icon-logoutinactive.1e98b795.svg";